<template>
	<b-dropdown-item
		class="notification-item p-0" :class="[{ 'unread': item.status === 'unread' }, { 'empty': isEmpty }]" @click="go">
		<div class="d-flex">
			<div class="notification__icon" v-if="!isEmpty">
				<div class="notification-icon">
					<i class="material-icons">{{ notificationIcon }}</i>
				</div>
			</div>
			<div class="notification__content">
				<div v-if="!isEmpty">
					<div class="notification__content__top">
						<div class="notification__type">{{ item.title }}</div>
						<div class="notification__time" :title="item.created_at">{{ time }}</div>
					</div>
					<div class="notification__message" v-html="item.text"></div>
				</div>
				<div class="empty" v-if="isEmpty">{{ emptyMessage }}</div>
			</div>
		</div>
	</b-dropdown-item>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import notificationsApi from '../api/notifications';

export default {
	name: 'notification',
	data() {
		return {
		};
	},
	props: {
		item: {
			type: Object,
		},
		notificationType: {
			type: String,
			default: 'general',
		},
	},
	mounted() {
	},
	methods: {
		go() {
			if (this.item.status !== 'read') {
				// Mark as read
				const callback = () => {};
				const ids = [this.item.id];
				notificationsApi.markAsRead(ids, callback);
			}

			let payload = this.item.payload;
			if (typeof payload === 'string') {
				payload = JSON.parse(payload);
			}

			if (this.item.type === 'message') {
				if (payload && payload.event_slug !== undefined) {
					const eventSlug = payload.event_slug;
					this.$router.push({ name: 'Messages', params: { eventSlug } });
				}
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		notificationIcon() {
			let iconName = 'notifications';
			if (this.item) {
				if (this.item.type === 'event') {
					iconName = 'calendar_today';
				} else if (this.item.type === 'agenda') {
					iconName = 'date_range';
				} else if (this.item.type === 'suggestion') {
					iconName = 'question_answer';
				} else if (this.item.type === 'suggestion_compare') {
					iconName = 'info';
				} else if (this.item.type === 'suggestion_share') {
					iconName = 'share';
				} else if (this.item.type === 'next_speaker') {
					iconName = 'record_voice_over';
				} else if (this.item.type === 'voting') {
					iconName = 'how_to_vote';
				} else if (this.item.type === 'message') {
					iconName = 'message';
				} else if (this.item.type === 'message_forward') {
					iconName = 'message';
				} else if (this.item.type === 'participant_leave') {
					iconName = 'directions_walk';
				}
			}
			return iconName;
		},
		isEmpty() {
			const isEmpty = this.item.type === 'empty';
			return isEmpty;
		},
		time() {
			const createdAt = this.item.created_at;
			let lang = this.user ? this.user.language : 'no';
			if (lang === 'no') {
				lang = 'nb';
			}
			const relativeTime = moment(createdAt, 'YYYY-MM-DD hh:mm:ss').locale(lang).fromNow();
			const time = !this.isEmpty ? relativeTime : '';
			return time;
		},
		emptyMessage() {
			let message = '';
			if (this.isEmpty) {
				if (this.notificationType === 'message') {
					message = this.$t('youDontHaveNewMessageNotifications');
				} else {
					message = this.$t('youDontHaveNewNotifications');
				}
			}
			return message;
		},
	},
};
</script>

<style lang="scss">
$icon_height: 25px;

// $color__order: #f06277;
$color__order: #FFCC29;
// $color__payment: #ffcc29;
$color__payment: #8AB94B;
$color__payment-confirmation: #75CFD8;
$color__facebook: #395A9A;
$color__limit: #ED3237;
$color__empty: #CED5D9;

.notification-item {
	display: flex;
	padding: 1.1em 1em;
	width: 100%;
	border-bottom: 1px solid #ddd;

	@media (min-width: 576px) {
		min-width: 400px;
	}

	&:active {
		color: inherit;
	}

	&:last-child {
		border-bottom: 0;
	}

	&.unread {
		// background-color: #e7fbfd;
		background-color: #edf2fa;
	}

	&.empty {
		pointer-events: none;
		text-align: center;
		padding: 10px !important;
	}
}

.notification__icon {
	padding-top: 4px;
	min-width: 35px;
}

.notification-icon {
	// width: $icon_height;
	// height: $icon_height;
	// text-align: center;
	// border-radius: 50%;
	// background-color: #ddd;

	// .material-icons {
	// 	font-size: 1em;
	// 	line-height: $icon_height;
	// }
}

.notification-icon-order {
	background-color: $color__order;

	.fa-icon {
		position: relative;
		left: -1px;
	}
}

.notification-icon-payment {
	background-color: $color__payment;
}

.notification-icon-payment-confirmation {
	background-color: $color__payment-confirmation;
}

.notification-icon-facebook {
	background-color: $color__facebook;
}

.notification-icon-limit {
	background-color: $color__limit;
}

.notification-icon-empty {
	background-color: $color__empty;
}

.notification__content {
	width: 100%;
	// max-width: 239px;
}

.notification__content__top {
	display: flex;
	justify-content: space-between;
}

.notification__type {
	min-width: 100px;
	font-weight: bold;
	font-size: 13px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 330px;
}

.notification__time {
	opacity: .6;
}

.notification__message {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 400px;
	font-size: 12px;
}

.notifications-list {
	.dropdown-item {
		padding: .4em 1.5em;
	}
}
</style>
